import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStep, PipelineStepRawData} from 'pipelines/PipelineTypes';
import {getPipelineStepRawDatasOfKind} from 'pipelines/StepDataUtils';

/**
 * The step data a Custom code step keeps the report of a cell script (custom code split into `# %%` cells) in: the
 * script rendered as HTML with its inputs, what each cell showed, and its outputs. A cell script that fails has its
 * report too, rendered up to the cell that failed.
 * Keep in sync with `CUSTOM_CODE_REPORT_STEP_DATA_NAME` in `step_shape_constants.py`.
 */
export const CUSTOM_CODE_REPORT_STEP_DATA_NAME = 'Report';

/** The report of a Custom code step that's a cell script, or null if it has none. */
export function findCustomCodeReport(
  step: PipelineStep
): PipelineStepRawData<PipelineStepDataKind.FILE> | null {
  if (step.stepType !== PipelineStepType.USER_DEFINED_FUNCTION) {
    return null;
  }
  const report = step.outputStepDatas.find((stepData) => stepData.name === CUSTOM_CODE_REPORT_STEP_DATA_NAME);
  if (report == null) {
    return null;
  }
  return getPipelineStepRawDatasOfKind(PipelineStepDataKind.FILE, report)[0] ?? null;
}
